//проверка на возможность отображения функционала в рамках договора
export function verifyAccess(pageRoles, selectedDog) {
    if (!selectedDog || !Array.isArray(selectedDog.roles)) return false
    const dogRoles = selectedDog.roles
        .map((r) => Number(r))
        .filter((n) => Number.isFinite(n))
    return pageRoles.some((role) => dogRoles.includes(Number(role)))
}

export function verifyParamMenu(parameter_menu, selectedDog) {
    if (!selectedDog) return false
    const required = (parameter_menu || []).map((pm) => String(pm).trim()).filter(Boolean)
    if (!required.length) return true
    const dogMenus = dogParameterMenus(selectedDog)
    return required.some((pm) => dogMenus.includes(pm))
}

/** Значения parameter_menu договора (может быть "2,4"). */
export function dogParameterMenus(selectedDog) {
    if (selectedDog?.parameter_menu == null || selectedDog.parameter_menu === '') return []
    return String(selectedDog.parameter_menu)
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
}

/**
 * Пункт меню виден, если parameter_menu пуст
 * или пересекается с набором значений договора (GL306: ключ 4).
 */
export function menuMatchesParameter(itemParameterMenu, selectedDog) {
    if (!itemParameterMenu || itemParameterMenu === '') return true
    const allowed = String(itemParameterMenu).split(',').map((s) => s.trim()).filter(Boolean)
    if (!allowed.length) return true
    const dogMenus = dogParameterMenus(selectedDog)
    return dogMenus.some((v) => allowed.includes(v))
}

export function dogHasParameterMenu(selectedDog, value) {
    return dogParameterMenus(selectedDog).includes(String(value))
}

const GP_FIX_PARAMETER_MENU = new Set(['2', '3'])

/** «Управление доступом»: роль 1; запрет, если у договора ГП/фикс (2 или 3). */
export function canAccessAdministration(selectedDog) {
    if (!verifyAccess([1], selectedDog)) return false
    const menus = dogParameterMenus(selectedDog)
    if (menus.some((code) => GP_FIX_PARAMETER_MENU.has(code))) return false
    return true
}

/**
 * Название пункта меню для пути с учётом parameter_menu договора:
 * один path может стоять в нескольких пунктах (напр. /debt — «Оплатить» для ГП/ФИКС и «Финансы» для НЭСК).
 * Без выбранного договора parameter_menu не фильтруется — как в боковом меню.
 */
export function findMenuText(items, path, selectedDog) {
    for (const item of items || []) {
        if (selectedDog && !menuMatchesParameter(item.parameter_menu, selectedDog)) continue
        const itemPath = item.path && !item.path.startsWith('/') ? `/${item.path}` : item.path
        if (itemPath === path) return item.text ?? null
        if (item.items) {
            const found = findMenuText(item.items, path, selectedDog)
            if (found) return found
        }
    }
    return null
}
